var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-x-mono"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8151 12L19.4661 6.349C19.5775 6.23757 19.666 6.10527 19.7264 5.95966C19.7867 5.81405 19.8178 5.65798 19.8179 5.50035C19.8179 5.34272 19.7869 5.18663 19.7266 5.04098C19.6664 4.89534 19.578 4.76299 19.4666 4.6515C19.3551 4.54 19.2228 4.45155 19.0772 4.39119C18.9316 4.33082 18.7755 4.29973 18.6179 4.29968C18.4603 4.29964 18.3042 4.33064 18.1585 4.39092C18.0129 4.45119 17.8805 4.53957 17.7691 4.651L12.1181 10.303L6.46605 4.651C6.23841 4.43837 5.93706 4.32251 5.62561 4.32787C5.31416 4.33323 5.01698 4.45938 4.79678 4.67971C4.57658 4.90003 4.4506 5.19729 4.44543 5.50875C4.44026 5.8202 4.5563 6.12148 4.76905 6.349L10.4211 12L4.76905 17.651C4.60201 17.8192 4.48843 18.033 4.4426 18.2656C4.39677 18.4982 4.42073 18.7391 4.51147 18.9581C4.60221 19.1771 4.75568 19.3644 4.95258 19.4964C5.14947 19.6284 5.381 19.6992 5.61805 19.7C5.92505 19.7 6.23205 19.583 6.46605 19.349L12.1181 13.697L17.7691 19.349C17.8803 19.4607 18.0126 19.5493 18.1582 19.6097C18.3038 19.6702 18.4599 19.7013 18.6176 19.7013C18.7752 19.7013 18.9313 19.6702 19.0769 19.6097C19.2225 19.5493 19.3548 19.4607 19.4661 19.349C19.5776 19.2375 19.6661 19.1052 19.7265 18.9595C19.7869 18.8138 19.818 18.6577 19.818 18.5C19.818 18.3423 19.7869 18.1861 19.7265 18.0405C19.6661 17.8948 19.5776 17.7624 19.4661 17.651L13.8151 12Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseWhite);
export default __webpack_public_path__ + "static/media/icon_close_white.a09f4a0e0f41d7f8c366085f52948487.svg";
export { ForwardRef as ReactComponent };